import Framework7 from 'framework7';
import store from '@/store';
import { ALL_LANGUAGES, RELEASE_VERSION } from '@/js/constants';
import EventBus from './event-bus';

let refreshTokenInProgress = false;
let refreshTokenResetHookAdded = false;

function safelyParseJson(value) {
  if (!value || typeof value !== 'string') {
    return null;
  }

  try {
    return JSON.parse(value);
  } catch (error) {
    return null;
  }
}

if (!refreshTokenResetHookAdded) {
  EventBus.$on('tokenRefreshed', () => {
    refreshTokenInProgress = false;
  });

  // Por si el refresh falla y el sistema invalida sesión
  EventBus.$on('authenticationFailed', () => {
    refreshTokenInProgress = false;
  });

  EventBus.$on('invalidTokenDetected', () => {
    refreshTokenInProgress = false;
  });

  refreshTokenResetHookAdded = true;
}

export default {
  request(
    url,
    payload,
    verb,
    processData = true,
    contentType = 'application/x-www-form-urlencoded',
    headerAuth,
    enabledCache,
    headerCompany = null,
    headerAdressCode = null,
    headerLang = null,
    callback,
    timeout = 180000,
    extraHeaders = null
  ) {
    const defaultHeaders = {
      company: headerCompany,
      address: headerAdressCode,
      lang: this.translateLanguage(headerLang),
      'app-version': RELEASE_VERSION,
    };

    if (headerAuth) {
      defaultHeaders.Authorization = headerAuth;
    }

    const requestHeaders = {
      ...defaultHeaders,
      ...((payload && payload.headers) || {}),
      ...(extraHeaders || {}),
    };

    Framework7.request.setup({
      headers: defaultHeaders,
    });
    return Framework7.request({
      url,
      method: verb,
      headers: requestHeaders,
      cache: enabledCache,
      data: payload.data,
      processData,
      contentType,
      timeout,
      complete: callback,
    });
  },

  translateLanguage(value) {
    let key = '';
    for (const lang in ALL_LANGUAGES) {
      if (ALL_LANGUAGES[lang].value === value) {
        key = ALL_LANGUAGES[lang].key;
      }
    }

    return key;
  },

  async(
    url,
    payload,
    verb,
    processData,
    contentType,
    headerAuth = null,
    headerCompany = null,
    headerAdressCode = null,
    enabledCache = false,
    extraHeaders = null
  ) {
    const self = this;
    let req = null;
    const p = new Promise((resolve, reject) => {
      req = self.request(
        url,
        payload,
        verb,
        processData,
        contentType,
        headerAuth,
        enabledCache,
        headerCompany,
        headerAdressCode,
        store.getters['user/getLanguage'],
        (xhr, status) => {
          if (status === 'abort') {
            reject(new Error('abort'));
            return;
          }

          if (status === 406) {
            window.location.reload();
          }
          if (status >= 300 || status === 'timeout') {
            if (status === 401) {
              const responseJson = safelyParseJson(xhr?.response);
              const code = responseJson?.code ?? '';

              if (code === 'token_not_valid') {
                if (!refreshTokenInProgress) {
                  refreshTokenInProgress = true;
                  EventBus.$emit('refreshToken');
                }
              } else if (
                responseJson?.errors?.[0]?.code ===
                'authentication_failed'
              ) {
                EventBus.$emit('authenticationFailed');
              } else {
                EventBus.$emit('invalidTokenDetected');
              }
            }
            if (status === 409) {
              resolve(xhr);
            }
            reject(new Error(`${xhr.response}`));
          }
          try {
            resolve(xhr);
          } catch (e) {
            reject(e);
          }
        },
        180000,
        extraHeaders
      );
    });

    p.abort = () => {
      try {
        if (req && req.abort) req.abort();
      } catch (e) {
      }
    };

    return p;
  },

  async blobRequest(url, callback) {
    const logoRes = await fetch(url);
    const blob = await logoRes.blob();
    const reader = new FileReader();
    reader.onloadend = () => callback(reader.result);
    reader.readAsDataURL(blob);
  },
};
